<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle">
      <div class="form-box card-base card-shadow--medium">
        <img
          class="image-logo"
          :src="logoURL"
          alt="logo"
          style="margin-bottom: 0"
        />

        <p class="text-center mb-0 white-text" style="font-size: 14.5px">
          Setup Two-Factor Authentication
        </p>

        <form @submit.prevent="submit" @keydown.enter="submit">
          <dads-select v-model="mode" placeholder="Select mode">
            <template slot="prefix">Mode</template>
            <el-option
              v-for="item in modeOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
          </dads-select>
          <div v-if="mode === 'sms'">
            <div class="el-input el-input--prefix">
              <input
                v-model="phoneNumber"
                ref="number"
                type="text"
                autocomplete="off"
                placeholder="Phone Number"
                class="el-input__inner"
                v-mask="'(###)-###-####'"
              />
              <span class="el-input__prefix">Phone Number</span>
            </div>
          </div>

          <div class="flex text-center pt-20 pb-10">
            <el-button
              type="primary"
              class="login-btn"
              @click="cancel"
            >
              Cancel
            </el-button>
            <el-button
              native-type="submit"
              type="primary"
              class="login-btn"
              :disabled="!formValid || processing"
              v-loading="processing"
            >
              Continue
            </el-button>
          </div>
        </form>
      </div>
    </div>
  </vue-scroll>
</template>

<script>
import DadsSelect from "@/components/select";
import { apiV2Host } from "@/feathers/feathers-client";

export default {
  name: "SetupMFA",

  components: {
    DadsSelect,
  },

  data() {
    return {
      processing: false,
      email: "",
      mode: "",
      phoneNumber: "",
      modeOptions: [
        {
          label: "Authenticator App",
          value: "app",
        },
        {
          label: "Email",
          value: "email",
        },
        {
          label: "SMS/Text Message",
          value: "sms",
        },
      ],
    };
  },

  watch: {
    mode() {
      if (this.mode === "email") {
        this.phoneNumber = "";
      }
      if (this.mode === "sms") {
        this.$nextTick(() => {
          this.$refs.number.focus();
        })
      }
    },
  },

  computed: {
    logoURL() {
      return this.$store.state.branding.logoOnlyURL;
    },

    formValid() {
      return this.mode === "sms"
        ? this.phoneNumber && this.phoneNumber.length === 14
        : !!this.mode;
    },
  },

  methods: {
    async submit() {
      try {
        this.processing = true;
        const { query } = this.$route;

        const body = {
          token: query.token,
          mode: this.mode,
        };

        if (this.mode === "sms") {
          body.phoneNumber = this.phoneNumber.replace(/-|\(|\)/g, "");
        }

        const res = await fetch(`${apiV2Host}/mfa/setup`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const json = await res.json();
        const {
          code,
          name,
          message,
          mfaVerifyToken,
          phoneNumber,
          secret,
          qrcode,
        } = json;

        this.processing = false;

        if (code && ["4", "5"].includes(`${code}`[0])) {
          this.$notify({
            title: name,
            message: message,
            type: "error",
          });
          return;
        }

        if (mfaVerifyToken) {

          if (this.mode !== 'app') {
            this.$notify({
              title: `Check your ${this.mode === 'sms' ? 'phone' : 'email'}`,
              message: "A 6-digit code has been sent.",
              type: "success",
            });
          }


          const query = { token: mfaVerifyToken, mode: this.mode };

          if (qrcode) {
            this.$store.commit("setQrcodeUrl", qrcode);
          }

          if (phoneNumber) {
            query.phoneNumber = phoneNumber;
          }

          if (secret) {
            query.secret = secret;
          }

          this.$router.push({
            path: "verify-mfa",
            query,
          });
        }
      } catch (err) {
        this.processing = false;
        this.$notify({
          title: err.name,
          message: err.message,
          type: "error",
        });
      }
    },

    cancel() {
      this.$router.replace("login");
    }
  },
};
</script>
